import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './reward.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { RewardList } from "model/bonus/rewardList.model";

export interface RewardListDetailsProps extends DetailsStateAndDispatchProps<RewardList>,
  RouteComponentProps, StateProps, DispatchProps {
}
const RewardListDetails: FC<RewardListDetailsProps> = (props) => {
  return (
    <DetailsPage<RewardList>
      title={'品牌详情'}
      {...props}
    >
      <ProDescriptions<RewardList>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ rewardList }: RootState) => ({
  entity: rewardList.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(RewardListDetails);
